// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileTopHeader_container__OZjtC","promotionalBarText":"MobileTopHeader_promotionalBarText__2F0Ge"};